import { render, staticRenderFns } from "./Factures.vue?vue&type=template&id=da3c13d4&"
import script from "./Factures.vue?vue&type=script&lang=js&"
export * from "./Factures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports